import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const StyledButtonPlus = styled.button`
  width: ${rem('36px')};
  height: ${rem('36px')};
  background-color: ${props => props.theme.colors.primary};
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color, 0.5s;
  ${props =>
    props.dark &&
    ` background-color: ${props.theme.colors.dark};
      &:hover{
        background-color: ${props.theme.colors.primary};
      }
    `};
`;

const StyledIcon = styled(Icon)`
  width: ${props => props.theme.icons[props.size].width};
  height: ${props => props.theme.icons[props.size].height};
`;

export { StyledButtonPlus, StyledIcon };
